module.exports = __webpack_public_path__ + "img/resource-tech-image-63.66ddb81b.jpg";